import { DynamicContentType } from '@bm-js/atlascloud-shared'
import { CText, Icon } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { contentTypeTrKeyMap } from '../utils/tr.util'

type Props = {
  contentType: DynamicContentType<unknown>
}

const ContentTypeTabItem = ({ contentType }: Props) => {
  const { tr } = useTr()
  return (
    <div className='border border-neutral-500 rounded flex flex-col items-center p-4 gap-1 text-black'>
      {!!contentType.icon && (
        <Icon size={28} strokeWidth={1.5} name={contentType.icon} />
      )}
      <CText className='text-sm font-semibold whitespace-nowrap'>
        {tr(contentTypeTrKeyMap[contentType.name])}
      </CText>
    </div>
  )
}

export default ContentTypeTabItem
